/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const BalanceType = {
  GiftCard: "GIFT_CARD",
  HouseAccount: "HOUSE_ACCOUNT",
} as const;

export type BalanceType = (typeof BalanceType)[keyof typeof BalanceType];

export type BalanceTypeEnumType = typeof BalanceType;
export type BalanceTypeOptional = BalanceType;
export type BalanceTypeTrackedI = BalanceType;
export type BalanceTypeTracked = BalanceType;
export type BalanceTypeMetaI = EnumMetaType<BalanceTypeEnumType, BalanceType>;
export const BalanceTypeMeta = typeMetaEnum<BalanceTypeEnumType, BalanceType>(
  "BalanceType",
  BalanceType,
);
export function transformDatesBalanceType(model: BalanceType) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
